module.exports = __webpack_public_path__ + "img/signingApproval2-icon.7079785a.png";